export default __webpack_public_path__ + "static/media/easygists.54056030.png";